import React from 'react';
import "./newrequeststyle.css";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { columns, data } from "./Datam";
import "./Datatable_styles.css";
import {useTranslation} from "react-i18next";

export default function BasicDemo() {
    // let data=data;

  const tableData = {
    columns,
    data:data
  };
  const { t } = useTranslation();
  // console.log("asdfasd",tableData)
 const paginationOptions = {
    rowsPerPageText: t("Rows_per_page"),
    rangeSeparatorText: t("Of"),
    selectAllRowsItem: true,
    selectAllRowsItemText: t("All"),
  };
  
  return (
    <div className="main">
      <DataTableExtensions {...tableData} filterPlaceholder="Search cardrequest">
        <DataTable
          columns={columns}
          data={data}
          noHeader
          defaultSortField="id"
          sortIcon={<SortIcon />}
          defaultSortAsc={true}
          pagination
          highlightOnHover
          dense
           paginationComponentOptions={{
                        ...paginationOptions,
                      }}
          noDataComponent={<div style={{padding:"24px"}}>{t("No_records_found")}</div>}
        />
      </DataTableExtensions>
    </div>
  );
}